import { useState, useMemo, useEffect, useCallback } from 'react'
import { Container, Box, useMediaQuery, useTheme } from '@material-ui/core'
import { Button, Grid } from '@mui/material'
import { useEthers, shortenAddress, TransactionStatus } from '@usedapp/core'
import { toast } from 'react-toastify'
import { ethers } from 'ethers'

import Card from './card'
import WalletConnectionModal from '../component/walletmodal'
import {
    useNoWalletContract 
} from '../hooks/useContract'
import useEstimateGas from '../hooks/useEstimateGas'
import {
    SocietyNobleContract,
    SocietyCoinContract,
    SocietyKeyContract,
    GoldAddress
} from '../global/constants'

import './about.scss'
import NeoTigerCard from './NeonTigerCard'
import SocietyH2oCard from './SocietyH2oCard'
import NobleStackCard from './NobleStackCard'
import P2pSwapCard from './P2pSwapCard'
import P2pSwapSocietyCard from './P2pSwapSocietyCard'
import NobleOz from './NobleOz'
import GoldTokenABI from '../abis/GoldToken.json'
import GoldPoolABI from '../abis/GoldPool.json'


const toastMsg = (state: TransactionStatus) => {
    if (state.status === 'PendingSignature')
        toast.info('Waiting for signature', { position: toast.POSITION.BOTTOM_RIGHT, hideProgressBar: true })

    if (state.status === 'Exception')
        toast.warning('User denied signature', { position: toast.POSITION.BOTTOM_RIGHT, hideProgressBar: true })

    if (state.status === 'Mining')
        toast.info('Pending transaction', { position: toast.POSITION.BOTTOM_RIGHT, hideProgressBar: true })

    if (state.status === 'Success')
        toast.success('Successfully confirmed', { position: toast.POSITION.BOTTOM_RIGHT, hideProgressBar: true })
}

const About = () => {
    const [wallet, setWallet] = useState(false)
    const { account } = useEthers()
    const [dynamicGoldBalance, setDynamicGoldBalance] = useState(0)
    const goldTokenContract: any = useNoWalletContract(GoldTokenABI, GoldAddress)

    const checkTokenBalance = async () => {
        try {
            if (account) {
                const blnc = await goldTokenContract.getUpdatedBalance(account)
                setDynamicGoldBalance(Number(blnc) / 1e6)
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (!account) return

        checkTokenBalance() // initial fetch

        const interval = setInterval(() => {
            checkTokenBalance()
        }, 10000) // every 10 seconds

        return () => clearInterval(interval)
    }, [account])

    const sendGold = useCallback(
        async (address: string | undefined = account, amount: string | undefined) => {
            try {
                const tokenAmount = ethers.utils.parseUnits(amount as string, 6)
                const tx = await goldTokenContract.transfer(address, tokenAmount)
                await tx.wait()
                await checkTokenBalance() // refresh after transfer
                toast.success('Transfer succeeded.', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    hideProgressBar: true,
                })
            } catch (error: any) {
                const msg = error?.error?.data?.message || error.message || 'Transaction failed'
                toast.error(msg.replace('execution reverted: ', ''), {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    hideProgressBar: true,
                })
            }
        },
        [account]
    )

    const copyAddress = (addressToCopy: string) => {
        navigator.clipboard.writeText(addressToCopy)
        toast.success('Copied', {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
        })
    }

    const adata = useMemo(
        () => [
            {
                imgurl: './img/Gold.png',
                copycontract: './img/copycontract.png',
                cointitle: 'TEMPLAR G✠LD',
                gifttitle: '',
                reward: 'reward',
                buttonname: 'Receive',
                background: '#88abc6',
                account: account,
                claim: sendGold,
                sendFunc: sendGold,
                copyAddress: () => copyAddress(SocietyKeyContract),
            },
        ],
        [dynamicGoldBalance, account]
    )

    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    return (
        <>
            <img src={'/img/TEMPLARBG.jpg'} id="myVideo" />

            <Box className='claims'>
                <WalletConnectionModal open={wallet} onClose={() => setWallet(false)} />
                <Container className='claim'>
                    <div className='claim-content'>
                        <div className='connects-wallet'>
                            <Button className='connects-button'>
                                <div onClick={() => setWallet(true)}>
                                    {account ? shortenAddress(account) : 'CONNECT WALLET'}
                                </div>
                                <img
                                    className='connects-button-refresh'
                                    src='./img/refresh.PNG'
                                    onClick={() => window.location.reload()}
                                />
                            </Button>
                        </div>

                        <div className='total-balance'>
                            <p className='balance-title'>TOTAL BALANCE</p>
                            <p className='balance-number'>
                                <img className='balance-number-img' src='./img/symbol.png' />
                                <span className='balance-number-money'>
                                    {Number(dynamicGoldBalance).toFixed(3)}
                                </span>
                            </p>
                        </div>
                    </div>

                    <div className='claim-gifts'>
                        <div>
                            <Grid container columns={12} direction='row' justifyContent='center'>
                                {adata.map((item, index) => (
                                    <Grid item xs={12} md={6} mt={2} key={index}>
                                        <Card {...item} />
                                    </Grid>
                                ))}
                            </Grid>

                            <Grid id="swap-card" container columns={12} direction='row' justifyContent='center'>
                                <Grid item xs={12} md={6} mt={2}>
                                    <P2pSwapSocietyCard />
                                </Grid>
                            </Grid>

                            <Grid container columns={12} direction='row' justifyContent='center'>
                                <Grid item xs={12} md={6} mt={2}>
                                    <NeoTigerCard />
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </Container>
            </Box>
        </>
    )
}

export default About